export default __webpack_public_path__ + "static/media/attachment-clip.21f3a8d6.svg";